(function () {
  const slideUp = (element, duration = 300) => {
    if (!element) return;
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideDown = (element, duration = 300) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;

    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const initReferences = (section) => {
    if (!section || !section?.classList.contains("references-section"))
      return;

    const toggle = section.querySelector(".references__toggle");
    const content = section.querySelector(".references__content");

    if (!toggle || !content) return;

    toggle.addEventListener("click", function () {
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      this.setAttribute("aria-expanded", !isExpanded);
      this.classList.toggle("active");

      if (isExpanded) {
        slideUp(content, 400);
      } else {
        slideDown(content, 400);
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".references-section").forEach(initReferences);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initReferences(event.target);
  });
})();
